import uuidv4 from 'uuid/v4';

class ScribeElementModel {
  constructor(data, type) {
    if (data && data.id) {
      this.id = data.id;
      this.type = data.type;
      this.width = data.width;
      this.height = data.height;
      this.x = data.x;
      this.y = data.y;
      this.duration = data.duration;

      this.angle = data.angle;
      this.scaleX = data.scaleX;
      this.scaleY = data.scaleY;

      this.flipX = data.flipX;
      this.flipY = data.flipY;
      this.originX = data.originX || 'left';
      this.originY = data.originY || 'top';
      this.unlockedRatio =
        typeof data.unlockedRatio !== 'undefined' ? data.unlockedRatio : ['Image', 'Shape'].includes(type);

      this.voiceoverText = data.voiceoverText;

      // `pauseTime` is a rename of `customPauseTime` so this needs to remain to maintain compatibility
      // with previously stored scribes
      this.pauseTime = typeof data.pauseTime === 'undefined' ? data.customPauseTime : data.pauseTime;

      this.animationTime = data.animationTime;
      this.locked = data.locked || false;

      this.cursorId = data.cursorId;
    } else {
      this.id = uuidv4();
      this.x = data.canvasSize.width / 2;
      this.y = data.canvasSize.height / 2;
      this.scaleX = 1;
      this.scaleY = 1;
      this.angle = 0;
      this.originX = 'left';
      this.originY = 'top';
      this.flipX = false;
      this.flipY = false;
      this.locked = false;
      this.unlockedRatio = ['Image', 'Shape'].includes(type);
      this.width = data.width;
      this.height = data.height;
    }

    this.type = type;
  }

  svg() {
    throw new Error('Not implemented');
  }
}

export default ScribeElementModel;
